import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TrashcanIcon from '@wix/da-ds/pkg/Icons/24x24/Trashcan';
import { PremiumTrash } from '@wix/da-ds/pkg/Icons/Confirmations';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { DeviationTypes } from '../../../types/deviation';
import TierCreatorReduxModule from '../../../Tier/redux/creator/ModuleLoadable';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import ConfirmationModal from '../../../Popup/ConfirmationModal';
import { deviationTypeToTranslationKey, getDeviationType, getDeviationResourceType } from '../../../DeviationViews/_helpers';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarEditButton from '../../_partials/items/ActionBarEditButton';
export const DeleteButton = ({ deviation, onClick })=>{
    const { t } = useTranslation();
    const [isShowingConfirmation, setShowingConfirmation] = useState(false);
    const logBiEvent = useBiLogger();
    const type = getDeviationType(deviation);
    const typeName = t(deviationTypeToTranslationKey(type));
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TierCreatorReduxModule, null), /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        tooltip: t('actionbar.delete')
    }, /*#__PURE__*/ React.createElement(ActionBarEditButton, {
        onClick: ()=>{
            if (type === DeviationTypes.TIER) {
                onClick({
                    deviation
                });
            } else {
                setShowingConfirmation(true);
            }
        },
        biData: {
            evid: BiEventType.DEVIATION_DELETE_CLICK,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId
        }
    }, /*#__PURE__*/ React.createElement(ActionBarIcon, {
        icon: TrashcanIcon
    }))), /*#__PURE__*/ React.createElement(ConfirmationModal, {
        isOpen: isShowingConfirmation,
        title: t('actionbar.delete.confirm', {
            type: typeName
        }),
        text: t('actionbar.delete.cantGoBack'),
        confirmBtnLabel: t('actionbar.delete'),
        cancelBtnLabel: t('popup.cancel'),
        icon: /*#__PURE__*/ React.createElement(PremiumTrash, null),
        confirmBtnType: "danger",
        onConfirm: ()=>{
            logBiEvent({
                evid: BiEventType.DELETE_DEVIATION_CONFIRM_CLICK,
                itemid: deviation.deviationId,
                typeid: getDeviationResourceType(deviation)
            });
            setShowingConfirmation(false);
            onClick({
                deviation,
                shouldRedirect: true
            });
        },
        onCancel: ()=>setShowingConfirmation(false)
    }));
};
DeleteButton.displayName = 'DeleteButton';
export default DeleteButton;
